export default "__VITE_ASSET__C9y2bs6S__"